import { useEffect, useRef, useState } from 'react';
import proximityLogo from '../../../assets/proximityLogo.png';
import headerImageMp4 from '../../../assets/proximity-critical-information-six-factor-smart-geomap-layering-tool.mp4';
import headerImage from '../../../assets/proximity-critical-information-six-factor-smart-geomap-layering-tool.webp';

const Header = () => {
  const [isSticky, setSticky] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        setSticky(ref.current.getBoundingClientRect().top <= 0);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      <div className="faq-header__initial-section">
        <div className="faq-header__content">
          <img
            className="faq-header__logo"
            alt="Proximity, map application interface shows data trends. Attach your operational data directly to geo-based business assets"
            src={proximityLogo}
          />
          <p className="faq-header__intro-heading">
            Mapping Business Intelligence
          </p>

          <p className="faq-header__description">
            Proximity is a smart geo-map layering tool to visualize the ‘live’
            status of different business entities in near real time
          </p>
        </div>
        <div className="faq-header__media">
          <video loop autoPlay muted playsInline id="hero-section-video">
            <source src={headerImageMp4} type="video/mp4" />
            <img
              alt="Proximity animation, our smart geo-map layering tool. Critical business information in the right place, at the right time"
              srcSet={headerImage}
            />
          </video>
        </div>
      </div>

      <div
        id="ofset"
        className={`faq-header__links-bar ${
          isSticky ? 'faq-header__links-bar--sticky' : ''
        }`}
        ref={ref}
      >
        <div className="faq-header__links">
          <button className="faq-header__button faq-header__button--structure">
            <a href="/faq#structure-section">Structure &amp; Navigation</a>
          </button>
          <button className="faq-header__button faq-header__button--faq">
            <a href="/faq#faq-section">FAQ Best Practice</a>
          </button>
          <button className="faq-header__button faq-header__button--guide">
            <a href="/faq#user-guide-section">User Guide</a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
